import { createRoot } from "react-dom/client";
import { App } from "./app";
import { GlobalContextProvider } from "~/GlobalContextProvider";
import { SyncProvider } from "~/context/SyncContext";
import LocationVerifier from "./LocationVerifier";

createRoot(document.getElementById("root")).render(
  <GlobalContextProvider>
    <SyncProvider>
        <App />
    </SyncProvider>
  </GlobalContextProvider>
);
